import React from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import { Trans } from 'react-i18next';
import { Button, Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import * as simulatorService from '../Application/Services/simulatorService';
import { useForm } from 'react-hook-form';
import FormInput from './Components/ReactHookFormCustom/FormInput';
import FormAsyncSelect from './Components/ReactHookFormCustom/FormAsyncSelect';

const Simulator = () => {
  const formJobs = useForm();
  const formApplicants = useForm();
  const formApplicantsOnly = useForm();
  const formSaveJson = useForm();

  // Adding Jobs
  const handleValidJobsSubmit = (values, event) => {
    simulatorService.createJobs(values.numJobs);
  };

  // Adding Applicants to a Job

  const handleValidApplicantsSubmit = (values, event) => {
    simulatorService.addApplicantsToAJob(values.numJobshandleValidApplicantsSubmit.value, values.numOfApplicants);
  };

  // Add Applicanst to random Jobs
  const handleValidRandomApplicantsSubmit = (values, event) => {
    simulatorService.AddApplicantsToRandomJobs(values.numOfRandomApplicants);
  };

  /* Async select */
  const getJobs = async (inputValue) => {
    const { data: jobs } = await simulatorService.getJobsForSelect(inputValue);
    return jobs;
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(getJobs(inputValue));
      }, 1000);
    });

  const onRemoveNewApplications = () => {
    simulatorService.removeNewApplicationStatuses();
  };

  const onRemoveNewApplicants = () => {
    simulatorService.removeNewApplicantStatuses();
  };

  const handleValidCreateJsonCompetencesSubmit = (values, event) => {
    simulatorService.CreateJsonCopyOfCompetences(values.locationToSaveJSONFile);
  };

  const onRemoveTenantsWithNoJobs = () => {
    simulatorService.RemoveTenantsWithNoJobs();
  };

  const fixNonAssignedApplicants = () => {
    simulatorService.fixNonAssignedApplicants();
  };

  //const modalError = this.state.error ? 'not' : ''; // This is just for the modal
  return (
    <ContentWrapper>
      <div className="content-heading">
        <div>
          Simulator (Only for Development purposes)
          <small>
            <Trans i18nKey="dashboard.WELCOME_BETA" />
          </small>
        </div>
      </div>
      <div>
        <Row>
          <Col>
            {/****** Jobs ******/}
            <Card className="card-default">
              <CardHeader>
                <h3>Create Jobs</h3>
              </CardHeader>
              <CardBody>
                <form id="addJobsForm" onSubmit={formJobs.handleSubmit(handleValidJobsSubmit)}>
                  <FormInput
                    control={formJobs.control}
                    name="numJobs"
                    label="Number of Jobs"
                    type="number"
                    min="1"
                    max="10000"
                    rules={{
                      required: 'Required',
                    }}
                  />
                  <Button color="primary">Add Jobs</Button>
                </form>
              </CardBody>
            </Card>
          </Col>
          <Col>
            {/******* Add Applicants to a specific Job *******/}
            <Card className="card-default">
              <CardHeader>
                <h3>Add applicants to a specific Job</h3>
              </CardHeader>
              <CardBody>
                <form
                  id="handleValidApplicantsSubmitId"
                  onSubmit={formApplicants.handleSubmit(handleValidApplicantsSubmit)}
                >
                  <FormAsyncSelect
                    cacheOptions
                    name="numJobshandleValidApplicantsSubmit"
                    control={formApplicants.control}
                    defaultOptions
                    rules={{ required: 'REQUIRED' }}
                    loadOptions={promiseOptions}
                  />
                  <FormInput
                    control={formApplicants.control}
                    name="numOfApplicants"
                    label="Number of applicants"
                    helpMessage="Number must be between 1 and 10000."
                    errorMessage="Number must be between 1 and 10000!"
                    type="number"
                    min="1"
                    max="10000"
                    required
                  />
                  <Button color="primary">Add applicants</Button>
                </form>
              </CardBody>
            </Card>
          </Col>
          <Col>
            {/******* Add Applicants to random Jobs *******/}
            <Card className="card-default">
              <CardHeader>
                <h3>Add applicants to random Jobs</h3>
                <small>Selects random Jobs from logged in Tenant and adds Applicants and Applications.</small>
              </CardHeader>
              <CardBody>
                <form onSubmit={formApplicantsOnly.handleSubmit(handleValidRandomApplicantsSubmit)}>
                  <FormInput
                    control={formApplicantsOnly.control}
                    name="numOfRandomApplicants"
                    label="Number of applicants"
                    type="number"
                    required
                  />
                  <Button color="primary">Add applicants</Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/******* Remove New from Applications *******/}
            <Card className="card-default">
              <CardHeader>
                <h3>Remove "New Status" from all Applications</h3>
              </CardHeader>
              <CardBody>
                <Button color="primary" onClick={onRemoveNewApplications}>
                  Click
                </Button>
              </CardBody>
            </Card>
          </Col>
          <Col>
            {/******* Remove New from Applicants *******/}
            <Card className="card-default">
              <CardHeader>
                <h3>Remove "New Status" from all Applicants</h3>
              </CardHeader>
              <CardBody>
                <Button color="primary" onClick={onRemoveNewApplicants}>
                  Click
                </Button>
              </CardBody>
            </Card>
          </Col>
          <Col>
            {/******* Create Json Copy Of Competences *******/}
            <Card className="card-default">
              <CardHeader>
                <h3>Create Json Copy Of Competences</h3>
              </CardHeader>
              <CardBody>
                <form onSubmit={formSaveJson.handleSubmit(handleValidCreateJsonCompetencesSubmit)}>
                  <FormInput
                    control={formSaveJson.control}
                    name="locationToSaveJSONFile"
                    label="Location to save JSON file"
                    helpMessage="Provide location on your computer. Eg: D:\\fileCompetences.txt"
                    errorMessage="Mandatory!"
                    required
                  />
                  <Button color="primary">Click</Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/******* Remove New from Applicants *******/}
            <Card className="card-default">
              <CardHeader>
                <h3>Remove All tenants with no jobs attached</h3>
                <p>Used for testing Register new user.</p>
                <p>This will work ONLY for admin users.</p>
              </CardHeader>
              <CardBody>
                <Button color="primary" onClick={onRemoveTenantsWithNoJobs}>
                  Click
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/******* Azure storage testing *******/}
            <Card className="card-default">
              <CardHeader>
                <h3>Fix non Assigned Applicants</h3>
                <p>Will bind non assigned applicants to the Recruiters which are responsible for the Job.</p>
              </CardHeader>
              <CardBody>
                <Button color="primary" onClick={fixNonAssignedApplicants}>
                  Click
                </Button>
              </CardBody>
            </Card>
          </Col>
          <Col></Col>
          <Col></Col>
        </Row>
      </div>
    </ContentWrapper>
  );
};

export default Simulator;
